/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [billboard-home-cover.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.03.20, 20:47
 */

import React, {Fragment, useState} from 'react';
import CoverUploadModal from "../upload/cover-upload-modal";
import CoverSlider from "../../slider/cover-slider";
import {getImageServerFullUrl, getPublicUserHome, getUserAvatar} from "../../../actions/environment";
import {useAuthorization, useHomeData} from "../../../selectors";
import HomeNavigation from "../../billboard-navigation/home/home-navigation";
import BillboardAvatarUpload from "./billboard-avatar-upload";
import CoverHolder from "../cover-holder";
import {PlaceOutlined} from "@material-ui/icons";
import {useIsMobile} from "../../configuration/configuration";


const BillboardHomeCover = ({username, location}) => {
    const [showUploadModal, setShowUploadModal] = useState(false);
    const {authorization, isAuthorized, isSuperUser, principal, isTransitioning} = useAuthorization();
    const {homedata, residence, user, space, isOwner} = useHomeData();
    const isMobile = useIsMobile();

    const renderCoverBanner = () => {
        if (!space.media) return <CoverHolder text={space.user.firstname}/>;

        switch (space.media.length) {
            case 0:
                return <CoverHolder text={space.user.firstname}/>;
            case 1:
                return <img className='cover-img position-center fit-cover'
                            src={getImageServerFullUrl(space.media[0].url, isMobile)}/>;
            default: // multiple slides
                return <CoverSlider space={space}/>
        }
    }

    // TODO resolve some semantic conflict with resolvedUser below
    const resolveUserName = () => {
        return isSuperUser && !isOwner ? user.username : authorization.principal.username;
    }

    const handleShowUploadDialog = (event) => {
        event.preventDefault();
        setShowUploadModal(!showUploadModal);
    }

    if (!homedata || isTransitioning) return null;

    const isPublicHome = !authorization.isAuthorized && location.pathname === getPublicUserHome();
    const resolvedUser = isOwner && principal ? principal : user;

    // TODO user needs to return current location

    return <Fragment>
        <div className='billboard-cover'>
            {renderCoverBanner()}

            <div className='billboard-avatar m-0 p-0'>
                {!isPublicHome && <div className='box-aligned lh-100'>
                    <img className='billboard-avatar-img' src={getUserAvatar(resolvedUser)} alt='Avatar'/>
                </div>}
                {isAuthorized && (isOwner || isSuperUser) &&
                    <BillboardAvatarUpload homedata={homedata}
                                           username={username}
                                           authorization={authorization}/>}
            </div>

            <div className='billboard-user-name'>
                <div>{user.fullname}</div>
                <div><PlaceOutlined/>{residence}</div>
            </div>

            {showUploadModal && isAuthorized && (isOwner || isSuperUser) &&
                <CoverUploadModal setIsOpen={setShowUploadModal}
                                  spacepath='home'
                                  username={resolveUserName()}/>}
        </div>
        <HomeNavigation location={location} username={username} onUpload={handleShowUploadDialog}/>
    </Fragment>
}

export default BillboardHomeCover;
